import { styled } from "@mui/system";
import {
  Card,
  CardContent,
  Stack,
  Typography,
  // Button,
  CardActionArea,
} from "@mui/material";
import { DisplaySettingsRounded } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";
// import { usePrint } from "../../hooks/usePrint";

const Root = styled(Card)({
  height: "100%",
  backgroundColor: "white",
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  position: "relative",
  overflow: "hidden",
});

const SolidLine = styled("div")(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "4%",
  backgroundColor: theme.palette.primary.lighter,
}));

// const handlePrint = async () => {
//     try {
//       const res = await fetch(process.env.REACT_APP_SERVER_URL + "/kitchen", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           orderNumber: "A-1024",
//           customerName: "John",
//           pickupType: "Pickup",
//           createdAt: new Date().toISOString(),
//           items: [
//             { quantity: 2, name: "Burger", note: "No onions" },
//             { quantity: 1, name: "Fries", modifiers: ["Large", "Extra salt"] },
//           ],
//           note: "Call customer when ready",
//         }),
//       });

//       if (!res.ok) {
//         const text = await res.text().catch(() => "");
//         console.error("Print failed:", res.status, text);
//         return;
//       }

//       console.log("Print sent!");
//     } catch (err) {
//       console.error("Request error:", err);
//     }
//   };
// const testInfo = {
//   orderEmail: "",
//   placedOrder: [],
//   orderName: "Test Order",
//   paymentMethod: "Credit Card",
// };

export const OrdersAmountWeek = () => {
  const { t } = useTranslation();
  // const { print } = usePrint();
  return (
    <Root>
      <SolidLine />
      {/* <Button onClick={() => print(orderEmail, placedOrder, orderName, paymentMethod)}> */}
      {/* <Button onClick={() => print(testInfo)}>
        Print Test Kitchen Ticket
      </Button> */}

      <CardActionArea
        component={RouterLink}
        to="/menu_items"
        sx={{ height: "100%", display: "flex" }}
      >
        <CardContent
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
            <DisplaySettingsRounded
              sx={{ fontSize: "48px", color: "primary.main", flexShrink: 0 }}
            />
            <Stack direction="column" spacing={0.5}>
              <Typography variant="h6">{t('menuItems')}</Typography>
              <Typography variant="body2" sx={{ opacity: 0.7 }}>
                {t('viewAndManageMenu')}
              </Typography>
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Root>
  );
};